var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickPensionUnselectedLarge = function SvgTickPensionUnselectedLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.629,
    cy: 20.688,
    r: 20,
    fill: "#FAFAFA",
    stroke: "#C3C3C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C3C3C3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m9.45 21.872 6.544 6.727L31.812 12.78"
  })));
};
export { SvgTickPensionUnselectedLarge as ReactComponent };
export default __webpack_public_path__ + "images/Tick_Pension_Unselected_Large.svg";